import { ReactElement } from 'react';

import './icons.css';

export const NewloanSVG = (): ReactElement => (
  <svg
    className="sidebarIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.00003 6.75C3.00003 4.67893 4.67896 3 6.75003 3H16.9105C18.9816 3 20.6605 4.67893 20.6605 6.75V16.9105C20.6605 18.9816 18.9816 20.6605 16.9105 20.6605H6.75003C4.67896 20.6605 3.00003 18.9816 3.00003 16.9105V6.75ZM6.75003 4.5C5.50739 4.5 4.50003 5.50736 4.50003 6.75V16.9105C4.50003 18.1531 5.50739 19.1605 6.75003 19.1605H16.9105C18.1532 19.1605 19.1605 18.1531 19.1605 16.9105V6.75C19.1605 5.50736 18.1532 4.5 16.9105 4.5H6.75003ZM11.0803 11.0802V7.34121H12.5803V11.0802H16.3193V12.5802H12.5803V16.3193H11.0803V12.5802H7.34124V11.0802H11.0803Z"
    />
  </svg>
);
